import { createAction, props } from "@ngrx/store";
import { IColorMap } from "../../interfaces/explorer/interfaces/colormap/IColorMap";

export const loadColorMaps = createAction('[Colormap] Load Colormaps');
export const loadColorMapsSuccess = createAction('[Colormap] Load Colormaps Success', props<{ colormaps: IColorMap[] }>());
export const loadColorMapsFailure = createAction('[Colormap] Load Colormaps Failure', props<{ error: any }>());